import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export function Badge({
  children,
  className,
  variant = "neutral",
}: {
  children: ReactNode;
  className?: string;
  variant?: "neutral" | "primary" | "success" | "warning" | "danger";
}) {
  return (
    <span
      className={cn(
        "inline-flex min-h-8 items-center rounded-full px-3 py-1 text-xs font-semibold tracking-[0.14em] uppercase",
        variant === "neutral" && "bg-muted text-muted-foreground",
        variant === "primary" && "bg-primary/12 text-primary",
        variant === "success" && "bg-success/14 text-success-foreground",
        variant === "warning" && "bg-warning/18 text-warning-foreground",
        variant === "danger" && "bg-destructive/12 text-destructive",
        className,
      )}
    >
      {children}
    </span>
  );
}
